
/**
 * @description 平台
 */

export const PLATFORM = {
  MP: 'wxapp',
  WXAPP: 'wxapp',
  WECHAT: 'weixin',
  WEIXIN_APP: 'weixin_app',
  APP: 'app',
  WEB: 'web',
  IOS: 'ios',
  ANDROID: 'android'
}
